export default __webpack_public_path__ + "static/pricingBg-85e869f30141c18a73f1ce07155c40b3.png";